import React from 'react';
import { Tree, Select, Icon, Button } from 'antd';
import classnames from 'classnames';
import _ from 'lodash'
const TreeNode = Tree.TreeNode;
const Option = Select.Option;

export class SearchTreeControl extends React.Component {
  constructor(props) {
    super(props);
    let filterProps = ['name'];
    let placeholder = null;
    let substractHeight = 0;
    if (props.config) {
      let config = null;
      try {
        config = JSON.parse(this.props.config);
      } catch (e) {
        config = {};
      }
      if (cb.utils.isArray(config.filters))
        filterProps = config.filters;
      if (config.placeholder)
        placeholder = config.placeholder;
      if (config.substractHeight)
        substractHeight = config.substractHeight;
    }
    this.state = {
      multiple: this.props.multiple || false,
      checkable: this.props.checkable || false,
      expandAll: this.props.expandAll || false,
      keyField: this.props.keyField || 'key',
      titleField: this.props.titleField || 'title',
      childrenField: this.props.childrenField || 'children',
      expandedKeys: this.props.expandedKeys || [],
      buttonGroup: this.props.buttonGroup || [{ type: 'edit-disabled' }],
      visible: !props.bHidden,
      autoExpandParent: false,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys:[],
      dataSource: [],
      optionData: [],
      renderFlag: true,
      searchValue: '',//搜索框的value
      selectKey: '',//搜索框下拉选中值
      filterProps: filterProps,
      placeholder: placeholder || "请输入关键字",
      substractHeight
    };
    this.selectDataSource = [];//拍平的datasource
  }

  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentDidUpdate() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentWillReceiveProps(nextProps) {
    let childrenField = this.state.childrenField;
    if (!nextProps.dataSource || this.props.id === nextProps.id) return;
    let states = { dataSource: nextProps.dataSource, optionData: nextProps.dataSource };
    if (this.state.expandAll) {
      let keyField = this.state.keyField;
      const expandedKeys = [];
      const loop = data => data.map((item) => {
        expandedKeys.push(item[keyField]);
        if (item[childrenField])
          loop(item[childrenField]);
      });
      loop(nextProps.dataSource);
      states.expandedKeys = expandedKeys;
    }
    this.setState(states);
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }
  setListenerState(data) {
    this.setState(data);
  }
  setCheckedKeys = (checkedKeys) => {
    var halfCheckKeys = [];
    if (!this.keyMap || cb.utils.isEmptyObject(this.keyMap)) this.keyMap = this.props.model.get('keyMap');
    var loop = (key, keyMap) => {
      var parent = keyMap[key] ? keyMap[key].parent : null;
      if (cb.utils.isEmpty(parent)) return
      parent = String(parent);
      if (keyMap[parent]) {
        if (checkedKeys.indexOf(parent) == -1 && halfCheckKeys.indexOf(parent) == -1) {
          halfCheckKeys.push(parent);
        }
        loop(parent, keyMap);
      }
    };
    checkedKeys.forEach(key => {
      loop(key, this.keyMap);
    });
    this.setState({ checkedKeys, "halfCheckedKeys": halfCheckKeys })
  }
  onSelect(selectedKeys, e) {
    if (this.props.onSelect)
      this.props.onSelect(selectedKeys, e);
    if (this.props.model) {
      if (this.props.model.modelType === 'GridModel')
        this.props.model.selectByKeys(selectedKeys);
      else
        this.props.model.select(selectedKeys);
    }
  }
  onCheck = (checkedKeys, e) => {
    let checkKeys = checkedKeys.checked, halfCheckKeys = checkedKeys.halfChecked;
    let key = e.node.props.eventKey;
    if (!this.keyMap || cb.utils.isEmptyObject(this.keyMap))
      this.keyMap = this.props.model.get('keyMap');
    let node = this.keyMap[key];
    if (e.checked) checkKeys.pop();
    let halfIndex = halfCheckKeys.indexOf(String(key));
    if (halfIndex != -1) halfCheckKeys.splice(halfIndex, 1);
    checkKeys = this.loopTreeNodes(node, checkKeys, e.checked);
    this.updateHaflCheckKeys(key, halfCheckKeys, checkKeys);
    if (this.props.model) this.props.model.check(checkKeys);
    this.setState({ 'halfCheckedKeys': halfCheckKeys });
  }
  loopTreeNodes = (node, checkKeys, bChecked) => {
    if (bChecked) {
      checkKeys.push(String(node[this.state.keyField]));
    } else {
      let keys = [];
      checkKeys.map((key, index) => {
        if (key != String(node[this.state.keyField]))
          keys.push(key);
      });
      checkKeys = keys;
    }
    if (node.children) {
      node.children.map(n => {
        checkKeys = this.loopTreeNodes(n, checkKeys, bChecked);
      });
    }
    return checkKeys;
  }
  updateHaflCheckKeys = (key, halfCheckKeys, checkKeys) => {
    let parent = this.keyMap[key] ? this.keyMap[key].parent : null;
    if (!parent) return halfCheckKeys;
    let checkedLen = 0, halfCheckedLen = 0, parentNode = this.keyMap[parent] || {};
    let childLen = parentNode.children ? parentNode.children.length : 0;
    parentNode.children && parentNode.children.map(node => {
      let childKey = String(node[this.state.keyField]);
      if (checkKeys.indexOf(childKey) != -1)
        checkedLen += 1;
      if (halfCheckKeys.indexOf(childKey) != -1)
        halfCheckedLen += 1;
    });
    let halfIndex = halfCheckKeys.indexOf(String(key));
    let parentHalfIndex = halfCheckKeys.indexOf(String(parent));
    let parentCheckIndex = checkKeys.indexOf(String(parent));
    if (checkedLen == 0) {
      if (halfCheckedLen == 0 && parentHalfIndex != -1)
        halfCheckKeys.splice(parentHalfIndex, 1);
      else if (halfIndex != -1 && parentHalfIndex == -1)
        halfCheckKeys.push(String(parent))
      if (parentCheckIndex != -1) checkKeys.splice(parentCheckIndex, 1);
    } else if (checkedLen == childLen) {
      if (parentHalfIndex != -1) halfCheckKeys.splice(parentHalfIndex, 1);
      if (parentCheckIndex == -1) checkKeys.push(String(parent));
    } else {
      if (parentHalfIndex == -1) halfCheckKeys.push(String(parent));
      if (parentCheckIndex != -1) checkKeys.splice(parentCheckIndex, 1);
    }

    if (parentNode.parent) this.updateHaflCheckKeys(parent, halfCheckKeys, checkKeys);
  }

  onExpand(expandedKeys, e) {
    if (e) { //通过点击＋或者-触发
      this.setState({ expandedKeys: expandedKeys, autoExpandParent: false });
    } else { //通过搜索触发
      this.setState({ expandedKeys: expandedKeys, autoExpandParent: true });
    }
  }

  searchSelect(value, option) {
    const { selectData, expandedKeys, dataSource } = this.state;
    const currentData = selectData.find(item => {
      return item.id == value;
    });
    const newExpandedKeys = [].concat(expandedKeys);
    if (!this.keyMap || cb.utils.isEmptyObject(this.keyMap)) this.keyMap = this.props.model.get('keyMap');
    const loopSetExpandKeys = (data) => {
      const expandedKey = data.parent.toString();
      if (newExpandedKeys.indexOf(expandedKey) === -1)
        newExpandedKeys.push(expandedKey);
      if (this.keyMap[expandedKey].parent) loopSetExpandKeys(this.keyMap[expandedKey]);
    };
    if (currentData && currentData.parent)
      loopSetExpandKeys(currentData);
    this.onExpand(newExpandedKeys);
    const _index = _.findIndex(dataSource, obj => {
      return obj.id == value
    })
    let ypos = _index * 28
    if (newExpandedKeys && newExpandedKeys.length == 0) {
      this.refs.scrollBody.scrollTo(0, ypos)
    }
    this.onSelect([value]);
  }
  fetch(value, callback) {
    const dataSource = this.selectDataSource;
    const { filterProps } = this.state;
    const data = [];
    dataSource.forEach(ele => {
      filterProps.forEach(field => {
        if (!ele[field] || ele[field].toString().indexOf(value) < 0) return;
        data.push(ele);
      });
    });
    callback(data);
  }
  getSelectData(data, parent) {
    const { childrenField } = this.props;
    data.forEach(function (ele) {
      const item = { parent: parent };
      for (var attr in ele) {
        if (attr === childrenField) continue;
        item[attr] = ele[attr];
      }
      this.selectDataSource.push(item);
      if (ele.children) {
        this.getSelectData(ele.children, ele.id)
      }
    }, this);
  }
  onSearch(value) {
    this.setState({ searchValue: value });
    this.fetch(value, selectData => this.setState({ selectData }));
  }
  getSearchOptions() {
    let searchValue = this.state.searchValue;
    if (searchValue == '') return
    let selectData = this.state.selectData;
    let options = [];
    if (!this.keyMap || cb.utils.isEmptyObject(this.keyMap)) this.keyMap = this.props.model.get('keyMap');
    if(selectData.length==0){
      options.push(<Option key='noResult' disabled={true}>暂无搜索结果~</Option>)
      return options;
    }
    selectData.forEach(function (ele) {
      let caption = ele[this.state.titleField];
      if(!cb.utils.isEmpty(ele.parent) && !cb.utils.isEmpty(this.keyMap[ele.parent]))
        caption = this.keyMap[ele.parent][this.state.titleField] + '/' + caption;
      options.push(<Option key={ele[this.state.keyField]}>{caption}</Option>)
    }, this);
    return options;
  }
  setDataSource(dataSource) {
    this.selectDataSource = [];
    this.getSelectData(dataSource);
    this.setState({ dataSource ,checkedKeys:[]});
  }
  handleSearchClick = (e) => {
    this.flag = true;
  }
  handleTreeClick = (e) => {
    this.flag = true;
  }
  handleClick = (e) => {
    if (this.flag) {
      this.flag = false;
      return;
    }
    this.onSelect([]);
  }
  onActionClick(e, id) {
    e.stopPropagation();
  }
  clearSearchValue = () => {
    this.setState({ searchValue: '' })
  }
  render() {
    let { titleField, keyField, childrenField, expandedKeys,dataSource } = this.state;
    let onlyLeaf = true;
    let childrenValue = dataSource.filter(v=>(v[childrenField]))
    let isChildren = childrenValue.length > 0  ? "tree-children" : "tree-nochildren"
    const loop = (data,isEnd) => data.map((item) => {
      let buttonGroup = this.state.buttonGroup.map((element) => {
        return <Icon type={element.type} onClick={(e) => this.onActionClick(e, item.id)} />
      })
      // let title = <span>{item[titleField]}{buttonGroup}</span>
      let title = <span>{item[titleField]}</span>
      let ID = JSON.stringify(item.id)
      if (item[childrenField]) {
        onlyLeaf = false;
        let index = expandedKeys.findIndex(key=>{
          //  基础服务设置的keyFiled 是code  所以key==parent_code
          return key == item[keyField] || key == item.parent || key == item['parent_' + keyField] || key == item['parent' + keyField[0].toLocaleUpperCase() + keyField.substring(1)];
        });
        if (index != -1 || !isEnd)
          return <TreeNode  id={ID} data={item} title={title} key={item[keyField]}>{loop(item[childrenField], true)}</TreeNode>;
        else
          return <TreeNode  id={ID} data={item} title={title} key={item[keyField]}></TreeNode>;
      }
      return <TreeNode  id={ID} data={item} title={title} key={item[keyField]} isLeaf={item.isLeaf} disabled={item.disabled} />;//onClick={}
    });
    const treeNodes = loop(dataSource);
    let treeProps = {
      // multiple: this.state.multiple,
      checkable: this.state.checkable || this.state.multiple,
      expandedKeys: this.state.expandedKeys,
      selectedKeys: this.state.selectedKeys,
      checkedKeys: { 'checked': this.state.checkedKeys, 'halfChecked': this.state.halfCheckedKeys },
      autoExpandParent: this.state.autoExpandParent,
      checkStrictly: true
    };
    let style = this.state.visible ? {} : { display: "none"};
    let options = this.getSearchOptions();
    const height = this.props.height - this.state.substractHeight;
    let tree3style = {};
    if (this.props.parentType == 'TreeTable')
      tree3style.height = height - 44;
    return (
      <div onClick={this.handleClick} className="bg-white border-r" style={{ width: '240px', height }}>
        <div onClick={this.handleSearchClick} className="search-tree-2">
          {this.state.searchValue ? <Icon type="close-circle" onClick={this.clearSearchValue} style={{ cursor: "pointer" }}></Icon> : null}
          <Button icon="search" />
          <Select placeholder={this.state.placeholder} mode="combobox" value={this.state.searchValue} notFoundContent="啊哦！没此节点哦！"
            onSelect={(value, option) => this.searchSelect(value, option)} onSearch={(value) => this.onSearch(value)}
            defaultActiveFirstOption={false} showArrow={false} filterOption={false} onChange={this.handleChange} dropdownMatchSelectWidth={false}>
            {options}
          </Select>
        </div>
        <div ref="scrollBody" style={tree3style} onClick={this.handleTreeClick} className={classnames("search-tree-3 edit", { 'only-leaf': onlyLeaf })}>
          <Tree  key={treeNodes.length} style={style}
          className={isChildren}
          onExpand={(expandedKeys, e) => this.onExpand(expandedKeys, e)}
          expandedKeys={this.state.searchValue} onSelect={(selectedKeys, e) => this.onSelect(selectedKeys, e)}
          onCheck={this.onCheck} {...treeProps}>
            {treeNodes}
          </Tree>
        </div>
      </div>
    )
  }
};
export default SearchTreeControl



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/SearchTree.jsx